import PropTypes from "prop-types";
import React from "react";

import { Button } from "@swa-ui/core";
import { classNames } from "@swa-ui/string";

import styles from "./BaseAuthenticationForm.module.scss";
import { LoginSubmitButton } from "./LoginSubmitButton";

export const ActionSection = (props) => {
  const { additionalButtonProps, stackedButtons, submitButtonText } = props;

  return stackedButtons ? (
    renderStackedButtons()
  ) : (
    <div className={styles.primary}>
      {additionalButtonProps && <Button {...additionalButtonProps} />}
      <LoginSubmitButton submitButtonText={submitButtonText} />
    </div>
  );

  function renderStackedButtons() {
    return (
      <div
        className={classNames({ [styles.buttonColumn]: stackedButtons, [styles.primary]: true })}
      >
        <LoginSubmitButton submitButtonText={submitButtonText} />
        {additionalButtonProps && <Button {...additionalButtonProps} />}
      </div>
    );
  }
};

ActionSection.propTypes = {
  /** Props to be passed to the additional button. */
  additionalButtonProps: PropTypes.shape(Button.propTypes),

  /** True when buttons should be full-width and stacked vertically */
  stackedButtons: PropTypes.bool,
};
